export enum ActionCode {
  SUPER_ADMIN_CODE = 'SuperAdmin',
  ADMIN_CODE = 'Admin',
  SECRETARY_USER_CODE = 'SecretaryUser',
  PHARMACY_USER_CODE = 'PharmacyUser',
}
